/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { createSlice } from "@reduxjs/toolkit";
import OrganizationState from "../../models/storeModels/OrganizationState";
import { getOrganizationByTenantID } from "./organisation-actions";

const initialSliceState: OrganizationState = {
  availableOrganization: [],
  hierarchicalOrganization: {},
  hierarchicalOrganizationwKey: [],
  treeTableOrganization: [],
  originalDataforTree: [],
  originalGetUserData: [],
  getCurrentUserData: {},
  expandedKeys: { 0: true },
  organisationDetailsToEdit: {
    tenantId: "",
    UserInfo: {
      key: "",
      data: {
        name: "",
        user: 0,
        organizationId: "",
      },
      parentId: "",
      children: [],
      version: 0,
      selectable: false,
      permissionSet: null,
    },
  },
  organizationUserPageDetails: {
    UserInfo: {
      key: "",
      data: {
        name: "",
        user: 0,
        organizationId: "",
      },
      parentId: "",
      children: [],
      version: 0,
      selectable: false,
      permissionSet: null,
    },
    tenantId: "",
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState: initialSliceState,

  extraReducers(builder) {
    // get OrganizationData
    builder
      .addCase(getOrganizationByTenantID.fulfilled, (state, action: any) => {
        state.availableOrganization = action.payload.originalData;
        state.hierarchicalOrganization = action.payload.convertedHierarchalData;
        state.hierarchicalOrganizationwKey =
          action.payload.hierarchicalOrganizationwKey;
        state.treeTableOrganization = action.payload.treeTableOrganization;
      })
      .addCase(getOrganizationByTenantID.rejected, (state, action) => {})
      .addCase(getOrganizationByTenantID.pending, (state) => {});

    // builder
    //   .addCase(getTreeTableOrganizationData.fulfilled, (state, action: any) => {
    //     state.originalDataforTree = action.payload.originalDataforTree;
    //     state.treeTableOrganization = action.payload.treeTableOrganization;
    //   })
    //   .addCase(getTreeTableOrganizationData.rejected, (state, action) => {})
    //   .addCase(getTreeTableOrganizationData.pending, (state) => {});

    // builder
    //   .addCase(getUserByTenantIDCutomerID.fulfilled, (state, action: any) => {
    //     state.getCurrentUserData = action.payload.currentUserData;
    //   })
    //   .addCase(getUserByTenantIDCutomerID.rejected, (state, action) => {})
    //   .addCase(getUserByTenantIDCutomerID.pending, (state) => {});
  },
  reducers: {
    setExpandedKeyforEdit(state, action) {
      state.expandedKeys = function1(action.payload);
    },
    organisationToEdit(state, action) {
      state.organisationDetailsToEdit = action.payload;
    },

    organisationUsersPage(state, action) {
      state.organizationUserPageDetails = action.payload;
    },
  },
});

const function1 = (x: any[]) => {
  //const convertedObject = {};

  const outputObject = Object.fromEntries(
    x.map((element: any) => [element, true])
  );
  let expandedKeys: any = { 0: true };
  for (const [key, value] of Object.entries(outputObject)) {
    expandedKeys[key] = value;
  }
  return expandedKeys;
};

export const organizationActions = organizationSlice.actions;

export default organizationSlice;
